<template>
  <div class="Membershipstyle" id="Membershipstyle">
    <div>
      <div class="Membershipstyle-top">
        <h1>{{ $t("Membershipstyle.title") }}</h1>
        <p>{{ $t("Membershipstyle.describe") }}</p>
      </div>
      <div class="Membershipstyle-view">
        <div v-for="(item, index) in Membershipstyle" :key="index" @click="onDateils(item)" class="Membershipstyle-item">
          <div class="video">
            <img :src="'./static/image/' + item.cover" alt="" />
            <img src="@/assets/Membershipstyle/icon.png" alt="" />
          </div>
          <div class="content">
            <p>{{ item.title }}</p>
            <p>{{ item.name }} | {{ item.company }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => {
    return {
      Membershipstyle: [],
      scrollTop:0
    };
  },
  computed: {
    list() {
      return this.$t("Membershipstyle.list");
    },
  },
  created() {
    this.intData()
  },
  
  methods: {
    onDateils(item) {
      this.$store.commit('SET_CODE',4)
      window.scrollTo({ top: 0 });
      this.$router.push({ path: "/member", query: { id: item.id } });
    },
 
    intData() {
      //引用axios
      const lang = localStorage.getItem("lang");
      switch (lang) {
        case 'en':
          axios.get("/static/lang/en.json", {})
            .then(({ data }) => {
              
              this.Membershipstyle = data.MembershipstyleList
            })
          break;
        case 'Czh':
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/Czh.json", {})
            .then(({ data }) => {
             
              this.Membershipstyle = data.MembershipstyleList
            })

          break;

        default:
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/zh.json", {})
            .then(({ data }) => {
             
              this.Membershipstyle = data.MembershipstyleList
            })

          break;
      }

    },
  },
};
</script>
<style lang="less" scoped>
::v-deep ::-webkit-scrollbar {
  // width: 1280px;
  // height: 2px;
  // color: transparent !important;
  // background: transparent !important;
}

.Membershipstyle {
  width: 100%;
  height: 585px;
  background-image: url("@/assets/Membershipstyle.png");
  background-size: cover;
  background-position: center;
  padding-top: 80px;
  box-sizing: border-box;

  >div {
    width: 1280px;
    margin: 0 auto;
  }

  .Membershipstyle-top {
    h1 {
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #fff;
      line-height: 56px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 22px;
    }
  }

  .Membershipstyle-view {
    width: 1280px;
    height: 290px;
    display: flex;
    overflow-x: scroll;

    // flex-wrap: nowrap;
    margin-top: 80px;

    .Membershipstyle-item {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      width: 530px;
      height: 258px;
      background: #ffffff;
      border-radius: 8px;
      padding: 12px;
      box-sizing: border-box;
      margin-right: 24px;
      cursor: pointer;

      .video {
        width: 234px;
        height: 234px;
        background: #000000;
        border-radius: 8px;
        position: relative;

        img {
          width: 234px;
          height: 234px;
          border-radius: 8px;
        }

        img:nth-child(2) {
          width: 35px;
          height: 35px;
          position: absolute;
          top: 100px;
          left: 100px;
        }
      }

      .content {
        height: 234px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        margin-left: 20px;

        P {
          font-size: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #000000;
        }

        p:nth-child(2) {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 22px;
        }
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .Membershipstyle {
    width: 108rem;
    height: 75rem;
    background-image: url("@/assets/Membershipstyle.png");
    background-size: cover;
    background-position: center;
    padding: 5rem;
    padding-top: 8remx;

    box-sizing: border-box;

    >div {
      width: 98rem;
      margin: 0 auto;
    }

    .Membershipstyle-top {
      h1 {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #fff;
        line-height: 7.3rem;
        margin-bottom: 2rem;
      }

      p {
        font-size: 3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #fff;
        line-height: 4.3rem;
      }
    }

    .Membershipstyle-view {
      width: 98rem;
      height: 40rem;
      display: flex;
      overflow-x: scroll;
      flex-wrap: nowrap;
      margin-top: 6.6rem;

      .Membershipstyle-item {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        width: 82rem;
        height: 40rem;
        background: #ffffff;
        border-radius: 1.3rem;
        padding: 2rem;
        box-sizing: border-box;
        margin-right: 5rem;
        cursor: pointer;

        .video {
          width: 36.3rem;
          height: 36.3rem;
          background: #000000;
          border-radius: 1.3rem;
          position: relative;

          img {
            width: 36.3rem;
            height: 36.3rem;
            border-radius: 1.3rem;
          }

          img:nth-child(2) {
            width: 7.1rem;
            height: 7.1rem;
            position: absolute;
            top: 10rem;
            left: 10rem;
          }
        }

        .content {
          height: 36.3rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          margin-left: 2.3rem;

          P {
            font-size: 4.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #000000;
          }

          p:nth-child(2) {
            font-size: 3.5rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 5rem;
          }
        }
      }
    }
  }
}
</style>